import OBTConfirm from './OBTConfirm';
export default OBTConfirm;
